var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIceLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 .577a2 2 0 012 0l5.794 3.346a2 2 0 011 1.732v6.69a2 2 0 01-1 1.732L10 17.423a2 2 0 01-2 0l-5.794-3.346a2 2 0 01-1-1.732v-6.69a2 2 0 011-1.732L8 .577z",
    fill: "#2E30F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.492 13.244l.007-8.49h1.012l-.007 8.49H8.492z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.398 11.566l-7.3-4.252.507-.881 7.3 4.25-.507.883z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6 11.56l7.307-4.239-.505-.882-7.306 4.238.505.883z",
    fill: "#fff"
  })));
}
export default SvgIceLogo;